import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureDisabledDirective, FeatureEnabledDirective } from './directives';
import { UnleashConfigToken, UnleashConfig } from './interfaces';
import { UnleashService } from './unleash.service';
import { filter, take, tap } from 'rxjs/operators';
import { ShopService } from '@services/shops/shop.service';

@NgModule({
  imports: [CommonModule],
  declarations: [FeatureDisabledDirective, FeatureEnabledDirective],
  exports: [FeatureDisabledDirective, FeatureEnabledDirective],
})
export class UnleashClientModule {
  static forRoot(config: UnleashConfig): ModuleWithProviders<UnleashClientModule> {
    return {
      ngModule: UnleashClientModule,
      providers: [
        { provide: UnleashConfigToken, useValue: config },
        {
          provide: APP_INITIALIZER,
          useFactory: (unleashService: UnleashService, shopService: ShopService) => () =>
            shopService.shop$
              .pipe(
                filter((shop) => !!shop),
                take(1),
                tap((shop) => {
                  unleashService.unleash.start();
                  const userContext = { shopId: shop.id + '' };
                  unleashService.unleash.updateContext({ properties: userContext });
                }),
              )
              .subscribe(),
          deps: [UnleashService, ShopService],
          multi: true,
        },
      ],
    };
  }
}
